// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkbox-mobile {\n  padding: 1px !important;\n  margin-top: 6px !important;\n}\n.checkbox-mobile .checkmark {\n  width: 30px;\n  height: 30px;\n}\n.checkbox-mobile .checkmark:after {\n  width: 7px !important;\n  height: 16px !important;\n  left: 11px !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
